module.exports = __webpack_public_path__ + "static/media/irelia.796a8d97.png";